import React, { useState } from 'react';
import { GetLoanDetails } from '../actions/api/APICalls';
import { setApplicationType, setCommitmentOrCertificateNumber, setLenderLoanNumber, setReceivedDate, setReceivedTime, setStatus, setStatusMessage, setSuspendReason, setLastDocReceivedDateTime } from '../actions/redux/setLoanStatusDetails';
import { store } from '../store/store';
import { loadingEffectStart, loadingEffectStop, primaryError, majorError } from '../actions/ui/effects';
import { addPendedReason } from '../actions/redux/addLoanStatusDetails';
import { useSelector } from 'react-redux';

function LoanSearchForm() {

    const [lastName, setLastName] = useState("");
    const [lenderLoanNumber, setLenderLoanNumber] = useState("");
    const [certOrCommitmentNumber, setCertOrCommitmentNumber] = useState("");

    const messages = useSelector(state => state.messages);
    const alertMessage = useSelector(state => state.alertDetails.alertMessage);
    const showAlert = useSelector(state => state.alertDetails.showAlert);
    const alertType = useSelector(state => state.alertDetails.alertType);

    return (
        <div id="loanSearchForm">
            {showAlert ?
                <div id="alertDiv" className={alertType} role="alert">
                    {alertMessage}
                </div> : null}
            <br />
            <form>
                <h4>Check Cert Status</h4>
                <br />
                <div className="mb-3">
                    <label htmlFor="lastNameField" className="form-label"><b>Please provide a last name</b></label>
                    <input id="lastNameField" type="text" className="form-control" placeholder="Last Name" onChange={(event) => { setLastName(event.target.value); }}></input>
                </div>
                <br />
                <div className="mb-3">
                    <label htmlFor="lenderLoanNumberField certOrCommitmentField" className="form-label"><b>And one of the following</b></label>
                    <input id="lenderLoanNumberField" type="text" className="form-control" placeholder="Lender Loan Number" defaultValue="" onChange={(event) => { setLenderLoanNumber(event.target.value) }}></input>
                    <br />
                    <input id="certOrCommitmentField" type="text" className="form-control" placeholder="Certificate / Commitment Number" defaultValue="" onChange={(event) => { setCertOrCommitmentNumber(event.target.value) }}></input>
                </div>
                <br />
                <div id="submitButtonContainer" >
                    <button id="submitButton" type="button" className="btn btn-primary" onClick={() => { submit(lastName, lenderLoanNumber, certOrCommitmentNumber, messages); }}>Submit</button>
                </div>
            </form>
        </div >
    );
}
async function submit(lastName, lenderLoanNumber, certOrCommitmentNumber, messages) {
    try {
        const msg_RequiredEntryCertOrLLN = messages?.loanSearchForm_RequiredEntryCertOrLLN;
        const msg_RequiredEntryLastName = messages?.loanSearchForm_RequiredEntryLastName;
        const msg_NoResultsFound = messages?.loanSearchForm_NoResultsFound;
        const msg_NoCertFound = "No cert found";

        let requestBody = {};
        loadingEffectStart();
        if (lastName !== "") {
            if (certOrCommitmentNumber !== "" && lenderLoanNumber === "") {
                requestBody = {
                    "certNumber": certOrCommitmentNumber,
                    "borrowerLastName": lastName
                };
            }
            else if (certOrCommitmentNumber === "" && lenderLoanNumber !== "") {
                requestBody = {
                    "lenderLoanNumber": lenderLoanNumber,
                    "borrowerLastName": lastName
                };
            }
            else {
                primaryError(msg_RequiredEntryCertOrLLN);
            }
            console.log(requestBody);
            let response = await GetLoanDetails(requestBody, { timeout: 30000 });
            if (requestBody.hasOwnProperty("borrowerLastName")) {
                if(!response.ok) {
                    primaryError(msg_NoCertFound);
                } else if (response.status >= 200 && response.status < 300) {
                    let responseBody = await response.json();
                    console.log(responseBody);
                    if (responseBody.table.length !== 0) {
                        writeValuesToReduxStore(responseBody.table[0]);
                        loadingEffectStop();
                    } else {
                        primaryError(msg_NoResultsFound);
                    }
                } else {
                    majorError(String(response.status));
                }
            }
        } else {
            try {
                primaryError(msg_RequiredEntryLastName);
            } catch (error) {
                console.log(error);
            }
        }
    } catch (error) {
        primaryError(String(error));
    }
}
function writeValuesToReduxStore(loanStatus) {
    try {
        store.dispatch(setCommitmentOrCertificateNumber(loanStatus.miSubId));
        store.dispatch(setLenderLoanNumber(loanStatus.lenderLoanNumber));
        store.dispatch(setApplicationType(loanStatus.applicationType));
        store.dispatch(setStatus(loanStatus.status));
        store.dispatch(setStatusMessage(loanStatus.statusDescription));
        store.dispatch(setReceivedDate(loanStatus.receivedDate));
        store.dispatch(setReceivedTime(loanStatus.receivedTime));
        store.dispatch(setReceivedTime(loanStatus.receivedTime));
        store.dispatch(setSuspendReason(loanStatus.suspendReason));
        store.dispatch(setLastDocReceivedDateTime(loanStatus.lastDocReceivedDateTime));
        Object.keys(loanStatus)
            .filter(item => item.includes("uwPendReason"))
            .forEach((item) => {
                store.dispatch(addPendedReason(loanStatus[item]));
            });
    } catch (error) {
        primaryError(String(error));
    }
}
export default LoanSearchForm;